export function formatDate(date) {
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  return new Date(date).toLocaleDateString("tr-TR", options);
}

export function calculateProgress(totalJuzs, completedJuzs, selectedJuzs) {
  return ((completedJuzs + selectedJuzs) / totalJuzs) * 100;
}

export function generateShareUrl(hatmId) {
  return `https://hatmedecem.com/hatimler/${hatmId}`;
}

export function cleanUserHatms(hatms, userId) {
    if (!hatms) return {};
    
    const cleanedHatms = {};
    
    Object.entries(hatms).forEach(([hatmId, hatmData]) => {
        if (hatmData && Object.keys(hatmData).length === 0) {
            cleanedHatms[hatmId] = {};
            return;
        }
        
        if (hatmData && typeof hatmData === 'object') {
            const cleanedJuzs = {};
            
            Object.entries(hatmData).forEach(([juzNumber, juzData]) => {
                if (juzData !== null) {
                    cleanedJuzs[juzNumber] = juzData;
                }
            });
            
            if (Object.keys(cleanedJuzs).length > 0) {
                cleanedHatms[hatmId] = cleanedJuzs;
            }
        }
    });
    
    return cleanedHatms;
} 